import { UIBackground } from '../ui/types';
import { $api } from '../y/api';
import { makeDataStore } from '../y/data-store';
import { YI18NString, YI18NId, YLanguage } from '../y/i18n';
import { YId, YFlags, YTimeString, YCountryId } from '../y/types';
import { FPageColorScheme, FPageSectionPadding, FPageDecoration, FPageBlock } from './f-page-block';

export interface FPageMetadata {
    title: YI18NString;
    description: YI18NString;
    og_title: YI18NString;
    og_description: YI18NString;
    og_image: YI18NId;
    in_sitemap: boolean;
    no_index: boolean;
    no_follow: boolean;
    sitemap_priority: number;
}

export type FPageFlag = 'inactive_cover';

export interface FPage {
    id: YId;
    name: string;
    resource_id?: string;
    is_locked: boolean;
    is_hidden: boolean;
    is_deleted: boolean;
    languages: YFlags<YLanguage>;
    metadata: FPageMetadata;
    flags: YFlags<FPageFlag>;
    deleted_at?: YTimeString;
    created_at: YTimeString;
    updated_at: YTimeString;
}

export interface FSectionProperties {
    bg: UIBackground;
    bg_sticky: boolean;
    color_scheme: FPageColorScheme;
    padding_top: FPageSectionPadding;
    padding_bottom: FPageSectionPadding;
    deco?: FPageDecoration;
    header: boolean;
}

export interface FSection {
    id: YId;
    is_shared: boolean;
    name?: string;
    countries: YFlags<YCountryId>;
    properties: FSectionProperties;
    blocks: FPageBlock[];
    created_at: YTimeString;
    updated_at: YTimeString;
}

export interface FPageSectionView extends FPage {
    sections: FSection[];
}

export const f_pages = makeDataStore('f/pages', 'f/page', (m: FPageSectionView) => m, Object.assign);

let f_pages_list_view: Promise<FPage[]> | undefined;
export function fPagesGetListView(reload?: boolean) {
    if(!f_pages_list_view || reload) {
        f_pages_list_view = $api.GET<FPage[]>('f/pages/list_view');
    }

    return f_pages_list_view;
}

export function fPageByResourceId(resource_id: string): Promise<FPageSectionView> {
    const existing = f_pages.all.find(p => p.resource_id === resource_id);
    if(existing)
        return Promise.resolve(existing);
    return $api.GET<FPageSectionView>(`f/page/by_resource/${resource_id}`).then(f_pages.register);
}
